import React, { useState } from "react";
import PropTypes from "prop-types";
import classes from "./footer.module.css";
import {
  facebookIconWhite,
  instaIcon,
  logo,
  tiktokIcon,
} from "../../constant/imagePath";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import { BsArrowRight } from "react-icons/bs";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { InputWithButton } from "../InputWithButton/InputWithButton";
import { ReactSVG } from "react-svg";

export const Footer = ({
  AppLogo,
  socialArray,
  pagesArray,
  copyRightText,
  backgroundColor,
  className,
}) => {
  let styleObject = Object.assign(
    {},
    backgroundColor && { backgroundColor: backgroundColor },
    className == undefined && { padding: "44px 5% 0%" }
  );
  const [email, setEmail] = useState("");

  return (
    <>
      <style jsx>{`
        .${classes.innerCol4}::before {
          border-top: 1px solid ${Colors.neutralShadesOfDimGray};
        }
      `}</style>
      <div
        style={styleObject}
        className={` ${[classes.FooterContainer].join(" ")}`}
      >
        <Container fluid className={`p-0 ${[className].join(" ")}`}>
          <Row className={`g-0 ${classes.firstRow}`}>
            <Col md={4} className={`${[classes.innerCol1].join(" ")}`}>
              <ReactSVG
                src={AppLogo}
                beforeInjection={(svg) => {
                  svg.classList.add(`${[classes.logo].join(" ")}`);
                }}
              />
              <Link to={'/socialSignupCoach'}>
                <span
                  style={{
                    color: Colors.white,
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                >
                  Become a coach
                </span>
              </Link>
            </Col>
            <Col
              md={4}
              className={`${[classes.innerCol2, classes.beforeBorder].join(
                " "
              )}`}
            >
              <div className={`${[classes.innerColSubContainer].join(" ")}`}>
                <ul>
                  {pagesArray.map((item, index) => (
                    <li>
                      <Link to={item?.link}>
                        <span style={{ color: Colors.white, ...Fonts.p4 }}>
                          {item?.title}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col
              md={4}
              className={`${[classes.innerCol3, classes.beforeBorder].join(
                " "
              )}`}
            >
              <div className={`${[classes.innerColSubContainer].join(" ")}`}>
                <span style={{ color: Colors.white, ...Fonts.h8 }}>
                  The best trainer lists right in your inbox
                </span>
                <InputWithButton
                  customStyle={{ marginTop: "24px", width: "100%" }}
                  iconClass={classes.btnIcon}
                />
              </div>
            </Col>
          </Row>
          <Row className="g-0">
            <Col md={12} className={`${[classes.innerCol4].join(" ")}`}>
              <div>
                <span
                  style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p4 }}
                >
                  {copyRightText}
                </span>
                <span
                  className={classes.break}
                  style={{ background: Colors.neutralShadesOfDimGray }}
                />
                <Link>
                  <span
                    style={{
                      color: Colors.neutralShadesOfDimGray,
                      ...Fonts.p4,
                    }}
                  >
                    Privacy
                  </span>
                </Link>
                <span
                  className={classes.break}
                  style={{ background: Colors.neutralShadesOfDimGray }}
                />
                <Link>
                  <span
                    style={{
                      color: Colors.neutralShadesOfDimGray,
                      ...Fonts.p4,
                    }}
                  >
                    Terms
                  </span>
                </Link>
              </div>
              <div className="d-flex">
                {socialArray.map((item, index) => (
                  <a href={item?.link} target="_blank">
                    <ReactSVG
                      src={item?.icon}
                      beforeInjection={(svg) => {
                        svg.classList.add(`${[classes.img].join(" ")}`);
                      }}
                    />
                  </a>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

Footer.propTypes = {
  AppLogo: PropTypes.string,
  socialArray: PropTypes.array,
  pagesArray: PropTypes.array,
  copyRightText: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
};

Footer.defaultProps = {
  AppLogo: logo,
  socialArray: [
    { link: "https://www.facebook.com", icon: facebookIconWhite },
    { link: "https://www.instagram.com", icon: instaIcon },
    { link: "https://www.tiktok.com", icon: tiktokIcon },
  ],
  pagesArray: [
    { title: "Partnership", link: "/partnership" },
    { title: "FAQ", link: "/help" },
    { title: "Become an investor", link: "/become-an-investor" },
    { title: "Contact us", link: "/contact-us" },
  ],
  copyRightText: "©2021 Lytesnap.com",
  backgroundColor: "#222222",
};
